/*
 * Note: This file is used to export all molecules components
 * so that we can import all molecules components from a single file
 * instead of importing each component individually
 * e.g. import { Component, componentVariants } from '@/components/ui/molecules';
 * instead of import { Component, componentVariants } from '@/components/ui/molecules/Component';
 */

import { ArticleShare } from "./article-share/ArticleShare"
import {
  CardAnnuaire,
  type ICardAnnuaireProps,
} from "./cards/card-annuaire/CardAnnuaire"
import { CardEvent, type ICardEventProps } from "./cards/card-event/CardEvent"
import {
  CardNewsEvent,
  type TCardNewsEventProps,
} from "./cards/card-news-event/CardNewsEvent"
import { CardNews } from "./cards/card-news/CardNews"
import { CardNewsSkeleton } from "./cards/card-news/CardNews.skeleton"
import {
  CardPartenaire,
  type TCardPartenaireProps,
} from "./cards/card-partenaire/CardPartenaire"
import { Card, type TCardProps } from "./cards/card/Card"
import { ChipFilterList } from "./chip-filter-list/ChipFilterList"
import { Footer, type IFooterProps } from "./footer/Footer"
import {
  INewsletterIframeProps,
  NewsletterIframe,
} from "./newsletter-iframe/NewsletterIframe"
import { PageTitle } from "./page-title/PageTitle"
import { Pagination, type TPagination } from "./pagination/Pagination"
import { Picture } from "./picture/Picture"
import { IVideoProps, Video } from "./video/Video"

export {
  Card,
  ChipFilterList,
  CardEvent,
  type ICardEventProps,
  type TCardProps,
  CardAnnuaire,
  type ICardAnnuaireProps,
  Footer,
  type IVideoProps,
  Video,
  type IFooterProps,
  NewsletterIframe,
  CardNewsEvent,
  type TCardNewsEventProps,
  type INewsletterIframeProps,
  Picture,
  CardPartenaire,
  type TCardPartenaireProps,
  CardNews,
  Pagination,
  type TPagination,
  PageTitle,
  ArticleShare,
  CardNewsSkeleton,
}
